"use strict";
var ɵngcc0 = require('@angular/core');
var ɵngcc1 = require('@angular/common/http');
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var operators_1 = require("rxjs/operators");
var deliverables_shared_service_1 = require("../deliverables-shared.service");
var deliverable_client_config_1 = require("../../deliverable.client.config");
var helpers_1 = require("../../helpers");
var i0 = require("@angular/core");
var i1 = require("@angular/common/http");
var i2 = require("../../deliverable.client.config");
var DeliverableService = /** @class */ (function () {
    /**
     * Initialises a new instance of the DeliverableService /> class.
     * @param http
     * @param config
     */
    function DeliverableService(http, config) {
        this.http = http;
        this.config = config;
    }
    /**
     * Add Phase.
     * @param addPhaseRequest
     * @returns An Observable containing the ProductLineCommonReadOnly
     */
    DeliverableService.prototype.AddPhaseAsync = function (addPhaseRequest) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/deliverables/addphase", addPhaseRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Adjust Term.
     * @param adjustDeliverableTermRequest
     * @returns An Observable containing the DeliverableBase
     */
    DeliverableService.prototype.AdjustTermAsync = function (adjustDeliverableTermRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/deliverables/adjustterm", adjustDeliverableTermRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Adjust Term Allowed.
     * @param adjustDeliverableTermRequest
     * @returns An Observable containing the BoolResponse
     */
    DeliverableService.prototype.AdjustTermAllowedAsync = function (adjustDeliverableTermRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/deliverables/adjusttermallowed", adjustDeliverableTermRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Amend Phase.
     * @param AmendPhaseTermRequest
     * @returns An Observable containing the ProductLineCommonReadOnly
     */
    DeliverableService.prototype.AmendPhaseAsync = function (AmendPhaseTermRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/deliverables/amendphase", AmendPhaseTermRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Amend Phase Allowed.
     * @param AmendPhaseTermRequest
     * @returns An Observable containing the BoolResponse
     */
    DeliverableService.prototype.AmendPhaseAllowedAsync = function (AmendPhaseTermRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/deliverables/amendphaseallowed", AmendPhaseTermRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Create Partial Async.
     * @param createPartialDeliverableRequest
     * @returns An Observable containing the DeliverableChildBase
     */
    DeliverableService.prototype.CreatePartialAsync = function (createPartialDeliverableRequest) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/deliverables/createpartial", createPartialDeliverableRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Create Full Async.
     * @param createFullDeliverableRequest
     * @returns An Observable containing the DeliverableChildBase
     */
    DeliverableService.prototype.CreateFullAsync = function (createFullDeliverableRequest) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/deliverables/createfull", createFullDeliverableRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Get.
     * @param id
     * @param ro
     * @param deliverableCriterias
     * @param selectCriterias
     * @returns An Observable containing the DeliverableChildBase
     */
    DeliverableService.prototype.GetAsync = function (id, ro, deliverableCriterias, selectCriterias) {
        if (ro === void 0) { ro = false; }
        var params = new http_1.HttpParams();
        if (ro)
            params = params.set('ro', ro.toString());
        //if (deliverableCriterias && deliverableCriterias.length >= 1)
        //  params .appendAll(model.DeliverableCriteriaHelper.convertDeliverableCriteriasToURLSearchParam(deliverableCriterias));
        //if (selectCriterias && selectCriterias.length >= 1)
        //  params.appendAll(model.SelectCriteriaHelper.convertSelectCriteriasToURLSearchParam(selectCriterias));
        return this.http.get(this.config.DeliverablesApiURL + "/api/deliverables/" + id, { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * List Async.
     * @param directOwnerIds
     * @param directOwnerTeamIds
     * @param anyAncestorOwnerIds
     * @param directProductInstanceIds
     * @param directOrPhaseProductInstanceIds
     * @param productDefinitionIds
     * @param productAllocationOwnerIds
     * @param assignableTypes
     * @param directParentDeliverableId
     * @param directParentPhaseId
     * @param ancestorDeliverableId
     * @param startDateFrom
     * @param endDateTo
     * @param feedIds
     * @param outcomeType
     * @param outcomeName
     * @param unitType
     * @param completed
     * @param started
     * @param belongsToContractIds
     * @param phaseAssignableTypes
     * @param directOrPhaseProductDefinitionIds
     * @returns An Observable containing the Array<DeliverableBase>
     */
    DeliverableService.prototype.ListAsync = function (directOwnerIds, directOwnerTeamIds, anyAncestorOwnerIds, directProductInstanceIds, directOrPhaseProductInstanceIds, productDefinitionIds, productAllocationOwnerIds, assignableTypes, directParentDeliverableId, directParentPhaseId, ancestorDeliverableId, startDateFrom, endDateTo, feedIds, outcomeType, outcomeName, unitType, completed, started, belongsToContractIds, phaseAssignableTypes, directOrPhaseProductDefinitionIds) {
        var params = new http_1.HttpParams();
        if (directOwnerIds)
            params = params.set('directOwnerIds', directOwnerIds.toString());
        if (directOwnerTeamIds)
            params = params.set('directOwnerTeamIds', directOwnerTeamIds.toString());
        if (anyAncestorOwnerIds)
            params = params.set('anyAncestorOwnerIds', anyAncestorOwnerIds.toString());
        if (directProductInstanceIds)
            params = params.set('directProductInstanceIds', directProductInstanceIds.toString());
        if (directOrPhaseProductInstanceIds)
            params = params.set('directOrPhaseProductInstanceIds', directOrPhaseProductInstanceIds.toString());
        if (productDefinitionIds)
            params = params.set('productDefinitionIds', productDefinitionIds.toString());
        if (productAllocationOwnerIds)
            params = params.set('productAllocationOwnerIds', productAllocationOwnerIds.toString());
        if (assignableTypes)
            params = params.set('assignableTypes', assignableTypes.toString());
        if (directParentDeliverableId)
            params = params.set('directParentDeliverableId', directParentDeliverableId.toString());
        if (directParentPhaseId)
            params = params.set('directParentPhaseId', directParentPhaseId.toString());
        if (ancestorDeliverableId)
            params = params.set('ancestorDeliverableId', ancestorDeliverableId.toString());
        if (startDateFrom)
            params = params.set('startDateFrom', startDateFrom.toString());
        if (endDateTo)
            params = params.set('endDateTo', endDateTo.toString());
        if (feedIds)
            params = params.set('feedIds', feedIds.toString());
        if (outcomeType)
            params = params.set('outcomeType', outcomeType.toString());
        if (outcomeName)
            params = params.set('outcomeName', outcomeName.toString());
        if (unitType)
            params = params.set('unitType', unitType.toString());
        if (completed)
            params = params.set('completed', completed.toString());
        if (started)
            params = params.set('started', started.toString());
        if (belongsToContractIds)
            params = params.set('belongsToContractIds', belongsToContractIds.toString());
        if (phaseAssignableTypes)
            params = params.set('phaseAssignableTypes', phaseAssignableTypes.toString());
        if (directOrPhaseProductDefinitionIds)
            params = params.set('directOrPhaseProductDefinitionIds', directOrPhaseProductDefinitionIds.toString());
        return this.http.get(this.config.DeliverablesApiURL + "/api/deliverables/", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Get With Contract.
     * @param id
     * @returns An Observable containing the DeliverableChildBase
     */
    DeliverableService.prototype.GetWithContractAsync = function (id) {
        return this.http.get(this.config.DeliverablesApiURL + "/api/deliverables/" + id + "/withcontract")
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * List By Ids Async.
     * @param ids
     * @returns An Observable containing the Array<DeliverableChildBase>
     */
    DeliverableService.prototype.ListByIdsAsync = function (ids) {
        var params = new http_1.HttpParams();
        if (ids)
            params = params.set('ids', ids.toString());
        return this.http.get(this.config.DeliverablesApiURL + "/api/deliverables/ids", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * List By Owner Id Async.
     * @param ownerId
     * @param completed
     * @returns An Observable containing the Array<DeliverableStub>
     */
    DeliverableService.prototype.ListByOwnerIdAsync = function (ownerId, completed) {
        var params = new http_1.HttpParams();
        if (ownerId)
            params = params.set('ownerId', ownerId.toString());
        if (completed)
            params = params.set('completed', completed.toString());
        return this.http.get(this.config.DeliverablesApiURL + "/api/deliverables/byownerid", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * List By Product Instance Ids Async.
     * @param ids
     * @param completed
     * @returns An Observable containing the Array<DeliverableStub>
     */
    DeliverableService.prototype.ListByProductInstanceIdsAsync = function (ids, completed) {
        var params = new http_1.HttpParams();
        if (ids)
            params = params.set('ids', ids.toString());
        if (completed)
            params = params.set('completed', completed.toString());
        return this.http.get(this.config.DeliverablesApiURL + "/api/deliverables/byproductinstanceids")
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Lock A Deliverable Term Async.
     * @param lockDeliverableTermRequest
     * @returns An Observable containing a boolean
     */
    DeliverableService.prototype.LockDeliverableTermAsync = function (deliverableId, lockDeliverableTermRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/deliverables/" + deliverableId + "/lock", lockDeliverableTermRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
       * Lock A Phase Term Async.
       * @param lockPhaseTermRequest
       * @returns An Observable containing a boolean
       */
    DeliverableService.prototype.LockPhaseTermAsync = function (deliverableId, phaseId, lockPhaseTermRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/deliverables/" + deliverableId + "/phases/" + phaseId + "/lock", lockPhaseTermRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Mark Complete Async.
     * @param markDeliverableCompleteRequest
     * @returns An Observable containing the DeliverableChildBase
     */
    DeliverableService.prototype.MarkCompleteAsync = function (markDeliverableCompleteRequest) {
        return this.http.patch(this.config.DeliverablesApiURL + "/api/deliverables/markcomplete", markDeliverableCompleteRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Mark Start Async.
     * @param markDeliverableStartedRequest
     * @returns An Observable containing the DeliverableChildBase
     */
    DeliverableService.prototype.MarkStartAsync = function (markDeliverableStartedRequest) {
        return this.http.patch(this.config.DeliverablesApiURL + "/api/deliverables/markstart", markDeliverableStartedRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Remove Phase.
     * @param ParentDeliverableId
     * @param PhaseId
     * @returns An Observable containing the boolean
     */
    DeliverableService.prototype.RemovePhaseAsync = function (ParentDeliverableId, PhaseId) {
        return this.http.delete(this.config.DeliverablesApiURL + "/api/deliverables/" + ParentDeliverableId + "/" + PhaseId + "/removephase")
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Save Tree Async.
     * @param deliverable
     * @returns An Observable containing boolean
     */
    DeliverableService.prototype.SaveTreeAsync = function (deliverable) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/deliverables/savetree", deliverable)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Post Outcome.
     * @param deliverableId
     * @param addOutcomeRequest
     * @returns An Observable containing the DeliverableOutcome
     */
    DeliverableService.prototype.PostOutcomeAsync = function (deliverableId, addOutcomeRequest) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/deliverables/" + deliverableId + "/outcomes", addOutcomeRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Put Outcome.
     * @param deliverableId
     * @param outcomeId
     * @param amendOutcomeRequest
     * @returns An Observable containing the DeliverableOutcome
     */
    DeliverableService.prototype.AmendOutcomeAsync = function (deliverableId, outcomeId, amendOutcomeRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/deliverables/" + deliverableId + "/outcomes/" + outcomeId, amendOutcomeRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Delete Outcome.
     * @param deliverableId
     * @param outcomeId
     * @returns An Observable containing boolean
     */
    DeliverableService.prototype.DeleteOutcomeAsync = function (deliverableId, outcomeId) {
        return this.http.delete(this.config.DeliverablesApiURL + "/api/deliverables/" + deliverableId + "/outcomes/" + outcomeId)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Set Outcome.
     * @param deliverableId
     * @param outcomeId
     * @param setOutcomeRequest
     * @returns An Observable containing boolean
     */
    DeliverableService.prototype.SetOutcomeAsync = function (deliverableId, outcomeId, setOutcomeRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/deliverables/" + deliverableId + "/outcomes/" + outcomeId + "/value", setOutcomeRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Transfer Owner.
     * @param deliverableId
     * @param transferOwnerRequest
     * @returns An Observable containing the IDeliverableFeatureEditable
     */
    DeliverableService.prototype.TransferOwnerAsync = function (deliverableId, transferOwnerRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/deliverables/" + deliverableId + "/owner", transferOwnerRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Put.
     * @param id
     * @param updateDeliverableRequest
     * @returns An Observable containing the DeliverableChildBase
     */
    DeliverableService.prototype.UpdateAsync = function (id, updateDeliverableRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/deliverables/" + id, updateDeliverableRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Delete.
     * @param id
     * @returns An Observable containing boolean
     */
    DeliverableService.prototype.DeleteAsync = function (id) {
        return this.http.delete(this.config.DeliverablesApiURL + "/api/deliverables/" + id)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Advanced Search.
     * @param page
     * @param pageSize
     * @param orderBy
     * @returns An Observable containing the model.IPagedList<DeliverableChildBase>
     */
    DeliverableService.prototype.AdvancedSearchAsync = function (page, pageSize, orderBy) {
        if (page === void 0) { page = 1; }
        if (pageSize === void 0) { pageSize = 10; }
        var params = new http_1.HttpParams();
        if (page)
            params = params.set('page', page.toString());
        if (pageSize)
            params = params.set('pageSize', pageSize.toString());
        if (orderBy)
            params = params.set('orderBy', orderBy.toString());
        return this.http.get(this.config.DeliverablesApiURL + "/api/deliverables/advancedsearch", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Advanced Search With Aggregate.
     * @param page
     * @param pageSize
     * @param orderBy
     * @returns An Observable containing the IDeliverablePagedList
     */
    DeliverableService.prototype.AdvancedSearchWithAggregateAsync = function (page, pageSize, orderBy) {
        var params = new http_1.HttpParams();
        if (page)
            params = params.set('page', page.toString());
        if (pageSize)
            params = params.set('pageSize', pageSize.toString());
        if (orderBy)
            params = params.set('orderBy', orderBy.toString());
        return this.http.get(this.config.DeliverablesApiURL + "/api/deliverables/advancedsearchwithaggregate", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    DeliverableService.ngInjectableDef = i0.defineInjectable({ factory: function DeliverableService_Factory() { return new DeliverableService(i0.inject(i1.HttpClient), i0.inject(i2.DELIVERABLE_CLIENT_CONFIG)); }, token: DeliverableService, providedIn: "root" });
    DeliverableService = __decorate([ __param(1, core_1.Inject(deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG)),
        __metadata("design:paramtypes", [http_1.HttpClient, Object])
    ], DeliverableService);
DeliverableService.ɵfac = function DeliverableService_Factory(t) { return new (t || DeliverableService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG)); };
DeliverableService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: DeliverableService, factory: function (t) { return DeliverableService.ɵfac(t); }, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DeliverableService, [{
        type: core_1.Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: Object, decorators: [{
                type: core_1.Inject,
                args: [deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG]
            }] }]; }, null); })();
    return DeliverableService;
}());
exports.DeliverableService = DeliverableService;

